export const dashboardConstants = {
  DASHBOARD_DATA_FAILURE: "DASHBOARD_DATA_FAILURE",
  DASHBOARD_DATA_SUCCESS: "DASHBOARD_DATA_SUCCESS",
};
